import { render, staticRenderFns } from "./ClickPush.vue?vue&type=template&id=5e6402ec&scoped=true"
import script from "./ClickPush.vue?vue&type=script&lang=js"
export * from "./ClickPush.vue?vue&type=script&lang=js"
import style0 from "./ClickPush.vue?vue&type=style&index=0&id=5e6402ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6402ec",
  null
  
)

export default component.exports